import TinyQueue from 'tinyqueue';

/*
 * Interface.
 */

export interface PriorityQueue<T> {
  readonly length: number;

  peek(): T | undefined;
  pop(): T | undefined;
  push(item: T): void;
  clear(): void;
}

/*
 * Factory.
 */

export function createPriorityQueueWithComparator<T>(compare: Comparator<T>): PriorityQueue<T> {
  return new TinyQueuePriorityQueue(compare);
}

/*
 * Implementation.
 */

type Comparator<T> = (a: T, b: T) => number;

class TinyQueuePriorityQueue<T> implements PriorityQueue<T> {
  private readonly compare: Comparator<T>;
  private queue: TinyQueue<T>;

  constructor(compare: Comparator<T>) {
    this.compare = compare;
    this.queue = this.createQueue();
  }

  private createQueue() {
    return new TinyQueue(undefined, this.compare);
  }

  get length() {
    return this.queue.length;
  }

  peek() {
    return this.queue.peek();
  }

  pop() {
    return this.queue.pop();
  }

  push(item: T) {
    this.queue.push(item);
  }

  clear() {
    this.queue = this.createQueue();
  }
}
